module.exports = __webpack_public_path__ + "static/media/person.b86d7108.svg";